<template>
  <div>
    <div class="p-5 mx-auto d-lg-none flex-column">
      <br />
      <br />
      <h1 align="left">{{ $t('about_us_title') }}</h1>
      <img class="image" src="@/assets/class.png" />
      <br />
      <br />
      <p align="left" v-html="$t('about_us_1')" />
      <br />
      <br />

      <img class="image" src="@/assets/ibacademy_wall.png" />
      <br />
      <br />
      <p align="left" v-html="$t('about_us_2')" />
    </div>

    <!-- <div class="about-body mx-auto p-5 d-none d-lg-flex flex-column">
      <div class="px-5">

        <h1 align="left">{{ $t('about_us_title') }}</h1>
      </div>
      <dev class="d-flex flex-row p-5">
        <p class="m-2" align="left" v-html="$t('about_us_1')" />
        <img class="m-2" src="@/assets/class.png" />

      </dev>
      <dev class="d-flex flex-row p-5">
        <div class="col-4">
          <img class="m-2" src="@/assets/ibacademy_wall.png" />
        </div>
        <div class="col-6">
          <p class="m-2" align="left" v-html="$t('about_us_2')" />
        </div>

      </dev>
    </div> -->
    <div class="about-body mx-auto d-none d-lg-flex">
      <div class="d-flex flex-wrap justify-content-center">
        <div class="col-4 d-flex flex-column align-items-stretch ">
          <h1 align="left">{{ $t('about_us_title') }}</h1>
          <img src="@/assets/class.png" />
          <br />
          <br />
          <p align="left" v-html="$t('about_us_1')" />
        </div>
        <div class="col-4 d-flex flex-column align-items-stretch">
          <img class="square" src="@/assets/ibacademy_wall.png" />
        </div>
        <br />


        <div class="d-flex flex-row justify-content-center">
          <div class="col-8">
            <p align="left" v-html="$t('about_us_2')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
<style lang="css">
.about-body {
  margin-top: 220px;
  margin-bottom: 220px;
}

.square {
  aspect-ratio: 1;
  object-fit: cover;

}
</style>